import React from 'react';
import { Criterias, Proposal, ProposalByProperty } from 'rsl-api-106/lib/types';

type TSearchContext = {
    proposals: ProposalByProperty[] | Proposal[] | null,
    setProposals: (
        proposals: ProposalByProperty[] | Proposal[] | null
    ) => void,
    criterias: Criterias | null,
    setCriterias: (
        criterias: Criterias
    ) => void,
    isSearching: boolean,
    setIsSearching: (
        isSearching: boolean
    ) => void
}

export const SearchContext = React.createContext<TSearchContext>({
    proposals: null,
    setProposals: () => { },
    criterias: null,
    setCriterias: () => { },
    isSearching: false,
    setIsSearching: () => { }
})